import CampaignCheck from "@/views/campaign/CampaignCheck";
import CampaignOmikuji from "@/views/campaign/CampaignOmikuji";
import CampaignOmikujiError from "@/views/campaign/CampaignOmikujiError";

export default {
  path: "/campaign/omikuji",
  component: CampaignCheck,
  children: [
    {
      path: ":id",
      name: "CampaignOmikuji",
      component: CampaignOmikuji
    },
    {
      path: "error",
      name: "CampaignOmikujiError",
      component: CampaignOmikujiError,
      props: true
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/campaign/index.js